export default __webpack_public_path__ + "static/ross-2c43c0da7902a9bf93fb29addb9d186c.jpg";